export const experiencesList = [
  {
    id: 1,
    image: './assets/icons/companies/solace.png',
    title: 'Solace',
    team: 'Cloud Infrastructure Team',
    dates: 'May 2025 - Present',
    skills: [
      'java',
      'spring boot',
      'react',
      'kubernetes',
      'helm',
      'github actions',
      'mysql',
      'terraform',
      'python',
    ],
    description:
      "Working on the Cloud Infrastructure team, building and maintaining the multi-cloud infrastructure that powers Solace's platform. Contributing to automation tooling, streamlining Kubernetes operations, optimizing cluster costs through node pool management, and improving system observability and incident response.",
  },
  {
    id: 2,
    image: './assets/icons/companies/nokia.png',
    title: 'Nokia',
    team: 'OAM Team',
    dates: 'Sep 2024 - Dec 2024',
    skills: ['c programming', 'networking'],
    description:
      'Worked as a member of the IP Routing OAM team, improving DMM/TWAMP test reliability, reducing packet loss, and refactoring stop logic to ensure memory safety and system stability in C/C++ routing environments.',
  },
  {
    id: 3,
    image: './assets/icons/companies/trend.png',
    title: 'Trend Micro',
    team: 'R&D Cloud One Workload Security Team',
    dates: 'May 2024 - Aug 2024',
    skills: ['java', 'aws', 'kubernetes', 'docker'],
    description:
      'Working on the R&D Cloud One Workload Security Team, aiding in driving the containerization of services within Deep Security Manager to improve deployment efficiency and scalability in AWS using Docker, Kubernetes, and AWS services.',
  },
  {
    id: 4,
    image: './assets/icons/companies/solace.png',
    title: 'Solace',
    team: 'Observability Team',
    dates: 'Jan 2024 - Apr 2024',
    skills: ['react', 'typescript', 'jest', 'python', 'datadog'],
    description:
      'Worked as a member of the PubSub+ Insights team, transitioning multiple pages from Aurelia to React, and implementing front-end testing strategies with Jest, Testing Library, and Cypress to enhance the Insights section of the operation console UI.',
  },
  {
    id: 5,
    image: './assets/icons/companies/entrust.png',
    title: 'Entrust',
    team: 'Verification Team',
    dates: 'Jan 2023 - Sep 2023',
    skills: ['docker', 'spring boot', 'java', 'mysql'],
    description:
      'Worked as a member of the Verification team, contributing to the Entrust cloud portal by enhancing UI, resolving bugs, and implementing features to streamline verification processes.',
  },
];
